import styled from "styled-components";
import borders from "theme/borders.module.scss";
import colors from "theme/colors.module.scss";
import spacing from "theme/spacing.module.scss";

export const Form = styled.form`
    width: 100%;
    .ant-form-item {
        margin-bottom: ${spacing.spacing};
    }
    .ant-input-number {
        width: 100%;
        border-radius: ${borders.borderRadiusSM};
    }
    .ant-input-lg {
        border-radius: ${borders.borderRadiusSM}; 
    }
    .ant-picker-outlined {
        border-radius: ${borders.borderRadiusSM};
    }
    button {
        border-radius: ${borders.borderRadiusSM};
    }
    .ant-select-selector {
        border-radius: ${borders.borderRadiusSM} !important;
        background-color: ${colors.primaryBackground} !important;
        width: 100%;
    }
    .ant-select-single {
        width: 100%;
    }
    .ant-color-picker-trigger {
        background-color: ${colors.primaryBackground}; 
    }
    
`;
